import { Method } from 'axios';
import { Executable } from '../executable';

export interface IUploadTemporaryFileResponse {
  uploadUrl: string;
  key: string;
}

export interface IUploadTemporaryFileInput {
  amount?: number;
  brandId: number;
}

export class UploadTemporaryFile
  extends Executable<IUploadTemporaryFileResponse[]>
  implements Partial<IUploadTemporaryFileInput>
{
  public amount: number = 1;

  public brandId?: number;

  public getMethod(): Method {
    return 'get';
  }

  public getResponse(apiResponse: any): IUploadTemporaryFileResponse[] {
    return apiResponse;
  }

  public getURLPath(tenantId?: string): string {
    return `${this.brandId}/uploads/temporary-upload?amount=${this.amount}`;
  }

  constructor(input?: Partial<IUploadTemporaryFileInput>) {
    super();
    if (input) {
      Object.assign(this, input);
    }
  }

  /**
   * getBody is used by the BambuClient to properly construct the request object body.
   * @returns Returns the expected body of the request utilizing the defined request attributes.
   */
  getBody() {
    return undefined;
  }

  /**
   * getRootPath is used by the BambuClient to properly construct the request call.
   * @returns The root path of the request
   */
  getRootPath(): string | undefined {
    return 'brands';
  }
}
